import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';

import PropResiSaleSearch_Dwk from '../dwk/propertyResi/PropResiSaleSearch'
import PropResiRentSearch_Dwk from '../dwk/propertyResi/PropResiRentSearch'
import PropComSaleSearch_Dwk from '../dwk/propertyCom/PropComSaleSearch'
import PropComRentSearch_Dwk from '../dwk/propertyCom/PropComRentSearch'

import PropResiSaleSearch_Ggn from '../gurgaon/propertyResi/PropResiSaleSearch'
import PropResiRentSearch_Ggn from '../gurgaon/propertyResi/PropResiRentSearch'
import PropComSaleSearch_Ggn from '../gurgaon/propertyCom/PropComSaleSearch'
import PropComRentSearch_Ggn from '../gurgaon/propertyCom/PropComRentSearch'

import { closeModal } from '../../actions/modalAction';

const actions = { closeModal };

class ShowImageModal extends Component {
  render() {
    
    return (
      <Modal 
      className='min-max-width'
      //size="tiny" 
      open={true} 
      onClose={this.props.closeModal}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      basic
      >
       
        <Modal.Content>
        {this.props.propRS_Dwk && <PropResiSaleSearch_Dwk/>}
        {this.props.propRR_Dwk && <PropResiRentSearch_Dwk/>}
        {this.props.propCS_Dwk && <PropComSaleSearch_Dwk/>}
        {this.props.propCR_Dwk && <PropComRentSearch_Dwk/>}

        {this.props.propRS_Ggn && <PropResiSaleSearch_Ggn/>}
        {this.props.propRR_Ggn && <PropResiRentSearch_Ggn/>}
        {this.props.propCS_Ggn && <PropComSaleSearch_Ggn/>}
        {this.props.propCR_Ggn && <PropComRentSearch_Ggn/>}
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(ShowImageModal);
